









































import BaseComponent from '@/components/base-component.vue';
import TranscriptionOcrModal from '@/components/prescription/form/transcription-ocr-modal.vue';
import UiFileUpload from '@/components/UI/file-upload.vue';
import UiInputFile from '@/components/UI/input-file.vue';
import { TranscricaoOcrParm, TranscricaoOcrResult } from '@/interfaces/transcricao-ocr';
import { continueTranscriptionOcr, execTranscriptionConferOcr, execTranscriptionOcr } from '@/services/prescription';
import { PDF_MIME_TYPES } from '@/settings/consts/file-upload';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    UiFileUpload,
    TranscriptionOcrModal,
    UiInputFile
  }
})
export default class TranscriptionOcr extends BaseComponent {
  @Prop()
  public item: any;

  @Prop()
  public isTranscription: boolean;

  private maxSizeMb: number = 10;
  private validTypes: string[] = PDF_MIME_TYPES;
  private file: any = null;
  private deleteFile: boolean = false;
  private ocr: Ocr = null;
  private modalResultOpen: boolean = false;

  public rules: any = {
    file: [(v) => !!v || 'Selecione o PDF original da prescrição']
  };

  @Watch('item')
  private onItemchange() {
    this.ocr = null;
    this.file = null;
  }

  onFileChange() {
    this.$emit('file', this.file);
    this.processar();
  }

  isProcessarOcr() {
    return (
      !this.item.isVisualization() &&
      !!this.item.unidade &&
      this.item.unidade.processaOcr === true &&
      ((!this.item.idTranscricao && !!this.file) || (!!this.item.idTranscricao && !!this.item.nomeArquivoTranscricao))
    );
  }

  private processar() {
    this.ocr = null;
    if (!this.isProcessarOcr()) {
      return;
    }

    this.loader.start('Processando OCR...');
    let obs = null;

    if (!this.item.idTranscricao) {
      let payload: any = {};
      payload.file = this.file;
      obs = execTranscriptionOcr(payload);
    } else {
      obs = execTranscriptionConferOcr(this.item.idTranscricao);
    }

    obs.subscribe(
      (res) => {
        this.processarResult(res);
      },
      (error) => {
        this.loader.stop();
        this.toast.show(error.data.message.replace(/\n/g, '</br>'), 'error', true, 8000);
      }
    );
  }

  private continuar() {
    let payload = new TranscricaoOcrParm();
    payload.key = this.ocr.key;
    payload.idUnidade = this.ocr.idUnidade;
    payload.idMedico = this.ocr.idMedico;
    payload.idPaciente = this.ocr.idPaciente;

    this.loader.start('Processando...');
    this.addSubsc(
      continueTranscriptionOcr(payload).subscribe(
        (res) => {
          this.processarResult(res);
        },
        (error) => {
          this.loader.stop();
          this.toast.show(error.data.message.replace(/\n/g, '</br>'), 'error', true, 8000);
        }
      )
    );
  }

  private processarResult(res) {
    this.loader.stop();
    this.modalResultOpen = true;
    setTimeout(() => {
      this.ocr = Object.assign(new Ocr(), res);
    }, 200);
  }

  private onCloseModal(ocr: Ocr) {
    this.modalResultOpen = false;
  }

  private onConfirmModal(ocr: Ocr) {
    this.modalResultOpen = false;
    this.ocr = this.aplicarAprovacaoOcr(ocr);
    this.$emit('changeOcr', this.ocr);
  }

  private aplicarAprovacaoOcr(ocr: Ocr): Ocr {
    if (!ocr) {
      return;
    }
    let apOcr = new Ocr();
    apOcr.key = ocr.key;

    if (!!ocr.aprovacaoValores['idUnidade']) {
      apOcr.idUnidade = ocr.idUnidade;
    } else {
      apOcr.ajustarUnidade = true;
      apOcr.ajustar = true;
      apOcr.msgUnidade = 'Unidade não identificada! Selecione ou cadastre manualmente e clique em continuar.';
    }
    if (!!ocr.aprovacaoValores['idMedico']) {
      apOcr.idMedico = ocr.idMedico;
    } else {
      apOcr.ajustarMedico = true;
      apOcr.ajustar = true;
      apOcr.msgMedico = 'Médico não identificado! Selecione ou cadastre manualmente e clique em continuar.';
    }
    if (!!ocr.aprovacaoValores['idPaciente']) {
      apOcr.idPaciente = ocr.idPaciente;
    } else {
      apOcr.ajustarPaciente = true;
      apOcr.ajustar = true;
      apOcr.msgPaciente = 'Paciente não identificado! Selecione ou cadastre manualmente e clique em continuar.';
    }
    apOcr.continuar = apOcr.ajustar;
    if (!!ocr.aprovacaoValores['pesoPaciente']) {
      apOcr.pesoPaciente = ocr.pesoPaciente;
    }
    if (!!ocr.aprovacaoValores['pesoCalorico']) {
      apOcr.pesoCalorico = ocr.pesoCalorico;
    }
    if (!!ocr.aprovacaoValores['registro']) {
      apOcr.registro = ocr.registro;
    }
    if (!!ocr.aprovacaoValores['leito']) {
      apOcr.leito = ocr.leito;
    }
    if (!!ocr.aprovacaoValores['divisaoBolsas']) {
      apOcr.divisaoBolsas = ocr.divisaoBolsas;
    }
    if (!!ocr.aprovacaoValores['volumeDesejado']) {
      apOcr.volumeDesejado = ocr.volumeDesejado;
    }
    if (!!ocr.aprovacaoValores['viaAdministracao']) {
      apOcr.viaAdministracao = ocr.viaAdministracao;
    }
    if (!!ocr.aprovacaoValores['tempoInfusao']) {
      apOcr.tempoInfusao = ocr.tempoInfusao;
    }

    apOcr.produtos = [];
    ocr.produtos.forEach((p) => {
      if (!!ocr.aprovacaoValores['p-' + p.id]) {
        apOcr.produtos.push(p);
      }
    });

    if (!apOcr.continuar) {
      apOcr.processado = true;
    }

    return apOcr;
  }

  @Watch('item.unidade')
  private onUnidadeChange(unidade) {
    this.processar();
  }

  @Watch('item.unidade.id')
  private onUnidadeIdChange(id: Number) {
    if (id && this.ocr && this.ocr.ajustarUnidade) {
      this.ocr.ajustarUnidade = false;
      this.ocr.idPaciente = id;
      this.conferirAjuste();
    }
  }

  @Watch('item.medico.id')
  private onMedicoIdChange(id: Number) {
    if (id && this.ocr && this.ocr.ajustarMedico) {
      this.ocr.ajustarMedico = false;
      this.ocr.idMedico = id;
      this.conferirAjuste();
    }
  }

  @Watch('item.paciente.id')
  private onPacienteIdChange(id: Number) {
    if (id && this.ocr && this.ocr.ajustarPaciente) {
      this.ocr.ajustarPaciente = false;
      this.ocr.idPaciente = id;
      this.conferirAjuste();
    }
  }

  private conferirAjuste() {
    this.ocr.ajustar = this.ocr.ajustarUnidade || this.ocr.ajustarMedico || this.ocr.ajustarPaciente;
    this.ocr = { ...this.ocr };
  }

  getHint() {
    if (!this.item || !this.item.unidade || this.item.isVisualization()) {
      return null;
    }
    if (this.item.unidade.processaOcr === false) {
      return 'Sem processamento OCR para a Unidade ' + this.item.unidade.nome;
    }
    return null;
  }

  isVisible() {
    return this.item && (!!this.item.nomeArquivoTranscricao || this.isTranscription);
  }

  isReadonly() {
    return !!this.item.idTranscricao || this.item.isVisualization() || !!this.item.nomeArquivoTranscricao;
  }
}

export class Ocr extends TranscricaoOcrResult {
  ajustarUnidade: boolean;
  ajustarMedico: boolean;
  ajustarPaciente: boolean;
  ajustar: boolean;
  continuar: boolean;
  processado: boolean;
  msgUnidade: string;
  msgMedico: string;
  msgPaciente: string;
  aprovacaoValores: boolean[] = [];
}
